import React from "react";
import BaseFormPage from "../../components/BaseFormPage";
import LoginForm from "./components/LoginForm";
import FormHeader from "../../components/FormHeader";
import { useTranslation } from "react-i18next";
import BaseTextButton from "../../components/BaseTextButton";
import NavigateToIfAuth from "../../hocs/NavigateToIfAuth";
import ROUTES from "../../utils/routes.js";
import { useLocation, useNavigate } from "react-router-dom";
import "./style.scss";
import SupportButton from "../../components/SupportButton";

export default NavigateToIfAuth(function LoginPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <>
      <BaseFormPage
        className="login-base-form-page"
        onNavigate={() => navigate(-1)}
        renderActionFormButton={() => (
          <BaseTextButton
            iconStyle="login-page-register-btn__btn-ic"
            className="login-page-register-btn"
            onClick={() =>
              navigate(ROUTES.REGISTER_PAGE, {
                state: { from: ROUTES.LOGIN_PAGE },
              })
            }
            icon="square_pencil"
          >
            {t("login_page.create_acc")}
          </BaseTextButton>
        )}
      >
        <FormHeader title={t("login_page.login_title")} />
        <LoginForm />
      </BaseFormPage>
      <div className="login-page-support-btn">
        <SupportButton />
      </div>
    </>
  );
}, ROUTES.PERSONAL_ACCOUNT_PAGE);
